export default function initCursorToolTip() {
    const cards = document.querySelectorAll(".card-tooltip");
    const tooltip = document.querySelector(".cursor-tooltip");

    if (tooltip) {
        tooltip.textContent = "";
        tooltip.style.opacity = 0;
    }

    if (!cards.length || !tooltip) {
        return;
    }

    cards.forEach(card => {
        card.addEventListener("mouseenter", () => {
            tooltip.textContent = card.getAttribute("data-tooltip");
            tooltip.style.opacity = 1;
        });

        card.addEventListener("mouseleave", () => {
            tooltip.style.opacity = 0;
        });

        card.addEventListener("mousemove", e => {
            tooltip.style.left = e.clientX + 15 + "px";
            tooltip.style.top = e.clientY + 15 + "px";
        });
    });
}
